import { useEffect } from 'react'
import { getCookie, setCookie } from 'chemistry'

export const useProductViewedTrack = productId => {
  useEffect(() => {
    let viewedProductsStr
    try {
      viewedProductsStr = getCookie('viewed-products')
    } catch (e) {
      viewedProductsStr = '[]'
    }

    if (viewedProductsStr) {
      const viewProductsArr = JSON.parse(viewedProductsStr)
        .filter(item => item !== productId)
        .slice(0, 9)
      viewProductsArr.splice(0, 0, productId)
      setCookie('viewed-products', JSON.stringify(viewProductsArr), { path: '/' })
    } else {
      setCookie('viewed-products', JSON.stringify([productId]), { path: '/' })
    }
  }, [productId])
}
